(function(window, wattpad, app, utils) {
  "use strict";

  app.router.on(
    "route:node-search",
    app.router.filter(["getTranslations", "getCategories"], function(
      query,
      resultType
    ) {
      query = query || "";
      const browseTopicsCollection = new app.collections.BrowseTopics();
      function navigateToView() {
        const view = new app.views.SearchLanding({
          query: query ? query.trim() : "",
          limits: { users: 10, stories: 3 },
          resultType: resultType || "stories",
          browseTopics: browseTopicsCollection
        });

        const title = utils.getSearchTitle(query);

        app.transitionTo(view, {
          hasHeader: true,
          hasFooter: true,
          pageTitle: title
        });

        let header = app.get("header-obj");
        if (header && header.searchFieldView) {
          header.isOnSearch = true;
          header.searchFieldView.isOnSearch = true;
        }

        // If the search term is empty, we have to assume they're on the search landing page
        if (!query.length) {
          window.te.push("event", "app", "page", null, "view", {
            page: "search"
          });
        } else {
          window.te.push("event", "app", "page", null, "view", {
            page: "search_results"
          });
        }
      }

      // Fetch browse topics for new home experience
      Promise.resolve(browseTopicsCollection.fetch()).then(function() {
        navigateToView();
      });
    })
  );
})(window, wattpad, window.app, wattpad.utils);
